<div class="quicklinks-container">
    <button data-qa="quicklinks" (click)="openQuickLinks()" class="quicklinks">My quick links</button>
</div>
<app-quicklinks-menu  (closeEvent)="setQuickLink($event)" [quickLinks]="quickLinks"></app-quicklinks-menu>
